import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import PasswordSchema, { PasswordParams } from "users/auth/credentials/passwords/password-schema";
import { ZodError } from "zod";

export default class Password {
  public static create(values: PasswordParams): Password {
    return new Password(values.password, values.confirmPassword);
  }

  public static fromJSON(json: unknown): Password | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const parsed = PasswordSchema.validateJSON(json);
    return new Password(parsed);
  }

  public constructor(public readonly password: string, confirmPassword?: string) {
    try {
      PasswordSchema.validate({ password, confirmPassword }, false);
      this.password = password;
    } catch (error) {
      if (error instanceof Error && error.cause instanceof ZodError && Array.isArray(error.cause.issues)) {
        throw new InvalidPasswordError(error.cause.issues.map((issue) => issue.message));
      }
    }
  }

  public get value(): string {
    return this.password;
  }

  public toJSON(): string {
    return this.password;
  }

  public isEqualTo(other: Password): boolean {
    return this.value === other?.value;
  }

  public toString(): string {
    return this.password;
  }
}

export class InvalidPasswordError extends Error {
  issues: string[];
  constructor(issues: string[]) {
    super(`Invalid password: ${issues.join(", ")}`);
    this.issues = issues;
  }
}
